import {GET_SHOPIFY_MERCHANTS, GET_WIX_MERCHANTS, GET_WP_MERCHANTS, RESET_LOADING, GET_SINGLE_WIX_MERCHANT, GET_SINGLE_WP_MERCHANT, GET_BIGCOMMERCE_MERCHANTS, GET_PORTAL_MERCHANTS, GET_SINGLE_BC_MERCHANT, GET_SINGLE_PORTAL_MERCHANT } from "../../actions/type";

  // activity intial state
  const initialMerchants = {
    shopifyMerchants: null,
    wixMerchants: null,
    wpMerchants: null,
    bcMerchants: null,
    portalMerchants: null,
    wixmerchantForEdit:null,
    wpmerchantForEdit:null,
    bcmerchantForEdit:null,
    portalmerchantForEdit:null,
    isLoading: true,
  };
  
  export const reducer = (state = initialMerchants, action) => {
    switch (action.type) {
      case GET_SHOPIFY_MERCHANTS:{
        const shopifyMerchants = action.payload
        return{
          ...state,
          shopifyMerchants: shopifyMerchants,
          isLoading: false,
        }
      }
      case GET_WIX_MERCHANTS: {
        const wixuser = action.payload;
        return {
          ...state,
          wixMerchants: wixuser,
          isLoading: false,
        };
      }

      case GET_WP_MERCHANTS: {
        const wpuser = action.payload;
        return {
          ...state,
          wpMerchants: wpuser,
          isLoading: false,
        };
      }

      case GET_BIGCOMMERCE_MERCHANTS: {
        const bcuser = action.payload;
        return {
          ...state,
          bcMerchants: bcuser,
          isLoading: false,
        };
      }

      case GET_PORTAL_MERCHANTS: {
        const portaluser = action.payload;
        return {
          ...state,
          portalMerchants: portaluser,
          isLoading: false,
        };
      }

      case GET_SINGLE_WIX_MERCHANT: {
        const wixmerchantForEdit = action.payload;
        return {
          ...state,
          wixmerchantForEdit,
          isEditLoading: false,
        };
      }

      case GET_SINGLE_WP_MERCHANT: {
        const wpmerchantForEdit = action.payload;
        return {
          ...state,
          wpmerchantForEdit,
          isEditLoading: false,
        };
      }

      case GET_SINGLE_BC_MERCHANT: {
        const bcmerchantForEdit = action.payload;
        return {
          ...state,
          bcmerchantForEdit,
          isEditLoading: false,
        };
      }
      
      case GET_SINGLE_PORTAL_MERCHANT: {
        const portalmerchantForEdit = action.payload;
        return {
          ...state,
          portalmerchantForEdit,
          isEditLoading: false,
        };
      }

      case RESET_LOADING: {
        return {
          ...state,
          isLoading: true,
          wixMerchants: null,
          wpMerchants: null,
          wixmerchantForEdit:null,
          wpmerchantForEdit:null,
          bcMerchants: null,
          portalMerchants: null,
        };
      }
     
      default:
        return state;
    }
  };